<div class="d-flex align-items-center justify-content-between w-100">
  <div class="d-flex align-items-center">
    <mbs-button
      class="cancel-btn"
      [isCtrl]="true"
      (click)="close()">
      <div class="p-2">
        <img
          src="assets/images/icons/union.svg"
          height="8px"
          width="8px"
          alt="" />
      </div>
    </mbs-button>

    <div class="d-flex align-items-center">
      <div class="app-icon">
        <img
          src="assets/msp-app-icon.png"
          height="60px"
          width="60px"
          alt="" />
      </div>
      <div class="ml-2">
        <div class="text-lg app-name">MSP360 Control</div>
        <div class="text-sm app-category">Utilities</div>
      </div>
    </div>
  </div>
  <button
    class="app-install-btn fw-bold text-uppercase"
    (click)="openInstallModal()">
    get
  </button>
</div>
